import api from '@api/Api';

export default {

    createAction(campaignId, params) {
        return api().post(`/actions/create/${campaignId}`, params);
    },

    sortActions(campaignId, params) {
        return api().put(`/actions/sort/${campaignId}`, params);
    },

    updateAction(id, params) {
        return api().put(`/actions/${id}`, params);
    },

    deleteAction(id) {
        return api().delete(`/actions/${id}`);
    },

    duplicateAction(id) {
        return api().post(`/actions/${id}/duplicate`);
    },

    testAction(id, type, params) {
        return api().post(`/actions/${id}/test/${type}`, params);
    },

    getBuilder(id) {
        return api().get(`/actions/builder/${id}`);
    },

}
